import { render, staticRenderFns } from "./ProductProvider.vue?vue&type=template&id=23cacd9b&scoped=true&"
import script from "./ProductProvider.vue?vue&type=script&lang=js&"
export * from "./ProductProvider.vue?vue&type=script&lang=js&"
import style0 from "./ProductProvider.vue?vue&type=style&index=0&id=23cacd9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cacd9b",
  null
  
)

export default component.exports